<template>
  <div>
    <div>
      <el-select
        :placeholder="placeholder"
        :filterable="filterable"
        :filter-method="filterValue"
        v-model="form[IDnams]"
        :style="{ width: width }"
        @change="selectChange"
        clearable
        :disabled="disabled"
        v-el-select-lazyloading="lazyloading"
      >
        <el-option
          v-for="(item, index) in options"
          :key="index"
          :label="
            item[labelKey] +
            (valueType == ''
              ? item[valueKey]
                ? ' / ' + item[valueKey]
                : ''
              : '')
          "
          :value="item[valueKey]"
        >
          <template>
            <span>{{ item[labelKey] }}</span>
            <span v-if="valueType == '' && item[valueKey]">
              / {{ item[valueKey] }}
            </span>
          </template>
        </el-option>
      </el-select>
    </div>
    <div>
      <slot></slot>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { getToken } from "@/utils/auth";
export default {
  name: "",
  props: {
    //value类型
    valueType: {
      type: String,
      default: "", //默认加了id
    },
    //绑定的id对象
    form: {
      type: Object,
      default: {
        id: "", //id
      },
    },
    //是否获取全部对象
    ObjeAll: {
      type: Boolean,
      default: false,
    },
    //
    disabled: {
      type: Boolean,
      default: false,
    },
    //绑定的id字段名
    IDnams: {
      type: String,
      default: "id",
    },
    //搜索关键字名
    queryKey: {
      type: String,
      default: "keyword",
    },
    //labelKey
    labelKey: {
      type: String,
      default: "name",
    },
    //valueKey
    valueKey: {
      type: String,
      default: "id",
    },
    //placeholder
    placeholder: {
      type: String,
      default: "请选择",
    },
    //urlType区分java还是php接口，//
    urlType: {
      type: String,
      default: "java",
    },
    //urltxt,url地址
    urltxt: {
      type: String,
      default: "",
    },
    //width
    width: {
      type: String,
      default: "",
    },
    //是否可搜索
    filterable: {
      type: Boolean,
      default: true,
    },
    //为请求方式(默认get请求)
    method: {
      type: String,
      default: "get",
    },
    //是否回显,回显数据
    Feedback: {
      type: [String, Number],
      default: "",
    },
    // 页码
    pageName: {
      type: String,
      default: "page",
    },
    // 每页大小
    perPageName: {
      type: String,
      default: "perPage",
    },
    // 是否分页
    Whepaginate: {
      type: Boolean,
      default: true,
    },
    // 是否
    ShowAll: {
      type: Boolean,
      default: true,
    },
    // 增加入参
    SeleData: {
      type: Object,
      default: () => {},
    },
    // 可新增
    addSelect: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      phpurl: "",
      appUrl: "",
      queryParams: {
        // page: 1, // 页码
        // perPage: 10, //每页大小
        creatorId: window.localStorage.getItem("userId"),
        businessId: window.localStorage.getItem("businessId"),
      },
      options: [], //会员列表（下拉框）
      time: null,
      lastRequestId: 0, // 记录最后一次请求的ID
      lastResponse: null, // 记录最后一次请求的响应数据
    };
  },

  created() {
    this.phpurl = window.localStorage.getItem("phpUrl");
    this.appUrl = window.localStorage.getItem("appUrl");
    this.init();
  },
  mounted() {},
  methods: {
    async init() {
      this.options = [];
      Object.assign(this.queryParams, this.$options.data().queryParams);
      this.$set(this.queryParams, this.pageName, 1);
      this.$set(this.queryParams, this.perPageName, 10);

      if (this.Feedback != "") {
        this.$set(this.queryParams, this.queryKey, this.Feedback);
        await this.filterValue(this.Feedback);
      } else {
        this.$set(this.queryParams, this.queryKey, "");
        await this.getList();
      }
    },
    // 下拉框懒加载
    lazyloading() {
      if (!this.Whepaginate) return;
      this.queryParams[this.pageName]++;
      this.getList();
    },
    // 获取会员列表（下拉框）
    async getList(res) {
      // console.log(111, res, this.queryParams);
      if (res) {
        if (res.data) {
          this.options = res.data.data;
        }
        if (res.content) {
          if (res.content.data) {
            if (res.content.data.length == 0 && this.addSelect) {
              res.content.data = [
                { id: "新增", name: this.queryParams.keyword },
              ];
            }
            this.options = res.content.data;
          } else if (res.content.list) {
            this.options = res.content.list;
          } else {
            this.options = res.content;
          }
          // if (res.content.list) {
          //   this.options = res.content.list;
          // }
        }
      } else {
        var downUrl = this.urlType == "java" ? this.appUrl : this.phpurl; //判断是否为java接口;
        var url = downUrl + this.urltxt;
        var params = { ...this.queryParams, ...this.SeleData };
        if (!this.ShowAll && this.queryParams[this.queryKey] == "") return;
        var res = await axios({
          method: this.method || "get",
          url: url,
          headers: { token: getToken() },
          [this.method == "post" ? "data" : "params"]: params,
        });
        res = res.data;
        if (res.code == 200 || res.code == "000000") {
          if (res.data) {
            this.options = JSON.parse(
              JSON.stringify([...this.options, ...res.data.data])
            );
          }
          if (res.content) {
            if (res.content.data) {
              this.options = JSON.parse(
                JSON.stringify([...this.options, ...res.content.data])
              );
            } else if (res.content.list) {
              this.options = JSON.parse(
                JSON.stringify([...this.options, ...res.content.list])
              );
            } else {
              this.options = JSON.parse(
                JSON.stringify([...this.options, ...res.content])
              );
            }
            // if (res.content.list) {
            //   this.options = JSON.parse(
            //     JSON.stringify([...this.options, ...res.content.list])
            //   );
            // }
          }
        }
      }
    },
    //选择
    async selectChange(id) {
      let name = "";
      if (id == "") {
        this.options = [];
        this.queryParams[this.pageName] = 1;
        this.queryParams[this.queryKey] = "";
        await this.getList();
      } else {
        this.options.forEach((value) => {
          if (value[this.valueKey] == id) {
            console.log(99999, value);
            this.form[this.IDnams] = id;
            if (this.form[this.IDnams] === "新增") {
              this.form[this.IDnams] = this.queryParams.keyword;
            }
            name = value[this.labelKey];
            //判断是否进行数据对象的赋值
            if (this.ObjeAll) {
              this.$emit("ObjeFrom", value);
            }
          }
        });
      }
      this.$emit("change", name);
    },
    //下拉框搜索
    async filterValue(value) {
      this.options = [];
      this.queryParams[this.pageName] = 1;
      this.queryParams[this.queryKey] = value;

      if (this.time) {
        clearInterval(this.time);
      }
      this.time = setTimeout(async () => {
        const requestId = Date.now(); // 生成一个唯一请求ID
        this.lastRequestId = requestId; // 记录最后一次请求ID
        try {
          var downUrl = this.urlType == "java" ? this.appUrl : this.phpurl; //判断是否为java接口;
          var url = downUrl + this.urltxt;
          var params = { ...this.queryParams, ...this.SeleData };
          if (!this.ShowAll && this.queryParams[this.queryKey] == "") return;
          var res = await axios({
            method: this.method || "get",
            url: url,
            headers: { token: getToken() },
            [this.method == "post" ? "data" : "params"]: params,
          });
          res = res.data;

          // 只保存最后一次请求的数据
          if (requestId === this.lastRequestId) {
            this.lastResponse = res;
            // 更新页面数据或进行其他操作
            this.getList(this.lastResponse);
          }
        } catch (error) {
          // 处理请求错误
          // console.error("请求错误:", error);
        }
      }, 1000);
    },
  },
};
</script>
<style lang="scss" scoped></style>
